import { Type } from "src/utils";

/**
 * 表示一个平台服务枚举。
 * @enum
 * @version 1.0.0
 */
enum SKCServerType
{
    /**
     * 平台版本服务(基础版; 专业版; 多机构版)
     * @member
     */
     BasicServer = 1,

    /**
     * 增值服务

     * @member
     */
     AddValServer = 2,

    /**
     * 组合服务 
     * @member
     */
     CompositionServer  = 3,

    /**
     * 权限服务 
     * @member
     */
     PermissionServer = 4
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(SKCServerType,
{
    BasicServer:
    {
        alias: "平台版本服务",
        description: ""
    },
    AddValServer:
    {
        alias: "增值服务",
        description: ""
    },
    CompositionServer:
    {
        alias: "组合服务",
        description: ""
    },
    PermissionServer:
    {
        alias: "权限服务",
        description: ""
    }
});

export default SKCServerType;